// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":" chevron-up-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.46436 13.2655L11.9999 9.73L15.5354 13.2655","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronUpSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-up-s',
    ref,
    icon: element,
  },
));

ChevronUpSIcon.displayName = 'ChevronUpSIcon';

export default ChevronUpSIcon;
